import { Banner } from "@proj/components";
import { RouterOutputs } from "../utils/trpc.js";
import ReactDOM from "react-dom";
import { useRef } from "react";

const STICKY_ID = "supabanner-sticky-container";
const PUSH_DOWN_ID = "supabanner-push-down-container";
const FIXED_BOTTOM_ID = "supabanner-fixed-bottom-container";
const FIXED_TOP_ID = "supabanner-fixed-top-container";

export function BannerPositioner({
  position,
  banner,
  children,
}: {
  position: "sticky" | "push-down" | "fixed-bottom" | "fixed-top";
  banner: RouterOutputs["getActiveBanners"]["banners"][number];
  children: React.ReactNode;
}) {
  // I think we want to make our own parent sticky container for multiple items.
  let stickyParentElem = document.getElementById(STICKY_ID);
  let pushDownParentElem = document.getElementById(PUSH_DOWN_ID);
  let fixedBottomParentElem = document.getElementById(FIXED_BOTTOM_ID);
  let fixedTopParentElem = document.getElementById(FIXED_TOP_ID);

  const elemRef = useRef<HTMLElement | null>(
    document.getElementById(`supabanner-push-down-banner-${banner.bannerId}`)
  );

  if (!elemRef.current) {
    elemRef.current = document.createElement("div");

    const elem = elemRef.current;

    elem.id = `supabanner-push-down-banner-${banner.bannerId}`;
    elem.setAttribute("data-supabanner-type", position);
    elem.setAttribute("data-supabanner-id", banner.bannerId.toString());
    // elem.classList.add("supabanner-fade-in");
  }

  const elem = elemRef.current;

  if (position === "push-down") {
    if (!pushDownParentElem) {
      pushDownParentElem = document.createElement("div");
      pushDownParentElem.id = PUSH_DOWN_ID;

      document.body.prepend(pushDownParentElem);
    }

    pushDownParentElem.append(elem);

    return ReactDOM.createPortal(children, elem);
  }

  if (position === "sticky") {
    if (!stickyParentElem) {
      stickyParentElem = document.createElement("div");
      stickyParentElem.id = STICKY_ID;
      stickyParentElem.setAttribute(
        "style",
        "top:0;position:sticky;z-index:9999999999;"
      );
      document.body.prepend(stickyParentElem);
    }

    stickyParentElem.append(elem);

    return ReactDOM.createPortal(children, elem);
  }

  if (position === "fixed-bottom") {
    if (!fixedBottomParentElem) {
      fixedBottomParentElem = document.createElement("div");
      fixedBottomParentElem.id = FIXED_BOTTOM_ID;
      fixedBottomParentElem.setAttribute(
        "style",
        "bottom:0;left:0;right:0;position:fixed;z-index:9999999999;"
      );

      document.body.append(fixedBottomParentElem);
    }

    fixedBottomParentElem.append(elem);

    return ReactDOM.createPortal(children, elem);
  }

  if (position === "fixed-top") {
    if (!fixedTopParentElem) {
      fixedTopParentElem = document.createElement("div");
      fixedTopParentElem.id = FIXED_TOP_ID;
      fixedTopParentElem.setAttribute(
        "style",
        "top:0;left:0;right:0;position:fixed;z-index:9999999999;"
      );

      document.body.append(fixedTopParentElem);
    }

    fixedTopParentElem.append(elem);

    return ReactDOM.createPortal(children, elem);
  }

  return null;
}
